import { Decimal, LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";

const selector = ({
  uniTokenBalance2,
  uniTokenAllowance2,
  liquidityMiningStake2
}: LiquityStoreState) => ({
  uniTokenBalance2,
  uniTokenAllowance2,
  liquidityMiningStake2
});

type FarmStakeValidation = {
  isValid: boolean;
  hasApproved: boolean;
  hasEnoughUniToken: boolean;
  isWithdrawing: boolean;
  amountChanged: Decimal;
  maximumStake: Decimal;
  hasSetMaximumStake: boolean;
};

export const useValidationState2 = (amount: Decimal): FarmStakeValidation => {
  const { uniTokenBalance2, uniTokenAllowance2, liquidityMiningStake2 } = useLiquitySelector(selector);
  const isWithdrawing = liquidityMiningStake2.gt(amount);
  const amountChanged = isWithdrawing
    ? liquidityMiningStake2.sub(amount)
    : Decimal.from(amount).sub(liquidityMiningStake2);
  const maximumStake = liquidityMiningStake2.add(uniTokenBalance2);
  const hasSetMaximumStake = amount.eq(maximumStake);

  if (isWithdrawing) {
    return {
      isValid: true,
      hasApproved: true,
      hasEnoughUniToken: true,
      isWithdrawing,
      amountChanged,
      maximumStake,
      hasSetMaximumStake
    };
  }

  const hasApproved = !uniTokenAllowance2.isZero && uniTokenAllowance2.gte(amountChanged);
  const hasEnoughUniToken = !uniTokenBalance2.isZero && uniTokenBalance2.gte(amountChanged);

  return {
    isValid: hasApproved && hasEnoughUniToken,
    hasApproved,
    hasEnoughUniToken,
    isWithdrawing,
    amountChanged,
    maximumStake,
    hasSetMaximumStake
  };
};